<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Crea una Orden de Compra</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-6 form-group mb-2">
							<label for="provider-order" class="form-label">Proveedor<span
								class="required">*</span></label>
							<div class="input-group">
								<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.provider"
									[placeholder]="'Ingresa una proveedor'" [filterElements]="filterProviders"
									[typeElements]="'warehouse-order'" (inputMethod)="writeProvider($event.event)"
									(changeStatus)="checkProvider($event.filterElement)"
									(getTitle)="$event.filterElement.title = $event.filterElement.name"></app-input-autocomplete>
							</div>
						</div>
						<div class="col-sm-3 form-group mb-2">
							<label for="date" class="form-label">Fecha Solicitud Orden<span
								class="required">*</span></label>
							<input type="date" [ngModel]="date | date:'yyyy-MM-dd'" [disabled]="true"
								name="date" id="date" class="form-control">
						</div>
						<div class="col-sm-3 form-group mb-2">
							<label for="date" class="form-label">Fecha de Entrega<span
								class="required">*</span></label>
							<input type="date" [ngModel]="deliveryDate | date:'yyyy-MM-dd'" (ngModelChange)="deliveryDate = $event"
								name="date" id="date" class="form-control">
						</div>
						
						<div class="col-sm-4 form-group">
							<label for="warehouse-order" class="form-label">Bodega<span
								class="required">*</span></label>
							<div class="input-group">
								<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.warehouse"
									[placeholder]="'Ingresa una bodega'" [filterElements]="filterWarehouses"
									[typeElements]="'warehouse-order'" (inputMethod)="writeWarehouse($event.event)"
									(changeStatus)="checkWarehouse($event.filterElement)"
									(getTitle)="$event.filterElement.title = $event.filterElement.name"></app-input-autocomplete>
							</div>
						</div>
						<div class="col-sm-4 form-group">
							<label for="product-order" class="form-label">Producto</label>
							<div class="input-group">
								<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.product"
									[placeholder]="'Ingresa un producto'" [filterElements]="filterProducts"
									[typeElements]="'product-order'" (inputMethod)="writeProduct($event.event)"
									(changeStatus)="checkProduct($event.filterElement)"
									(getTitle)="$event.filterElement.title = $event.filterElement.code+  ' - '+ $event.filterElement.name"></app-input-autocomplete>
							</div>
						</div>
						<div class="col-sm-4 form-group">
							<label for="ammount" class="form-label">Cantidad</label>
							<div class="input-group">
								<input type="number" name="ammount" id="ammount" [(ngModel)]="quantity"
								class="form-control"
								[min]="0"
									>
								<button class="btn btn-primary" 
								(click)="addProduct()" 
								title="Agregar producto" 
								[disabled]="!inputs.product.verified || quantity <= 0">
									<span class="superposition-container">
										<i class='fa fa-boxes'></i>
										<i style="color: yellow;" class="fa fa-plus superposition-element"></i>
									</span>
								</button>
							</div>
						</div>
					</div>
					<div class="row mt-4" *ngIf="productList.length > 0">
						<div class="col">
							<div class="table-responsive product-table-scroll">
    								<table class="table table-striped">
									<thead>
										<tr>
											<th colspan="4">Producto</th>
											<th class="text-right">Cantidad</th>
											<th class="text-center">Costo</th>
											<th class="text-center">
												Moneda <button class="btn btn-sm btn-light btn-info" (click)="updateExchange()" [disabled]="loadingCurrency">
													<i *ngIf="!loadingCurrency" class="fa fa-exchange"></i>
													<i *ngIf="loadingCurrency" class="fa fa-spinner"></i>
													<span *ngIf="currencyType==0">{{ ' $' }}</span>
													<span *ngIf="currencyType==1">{{ ' Q' }}</span>
												</button>
												<!-- <span class="btn btn-sm btn-light btn-info">
													<i *ngIf="!loadingCurrency" class="fa fa-exchange"></i>
													<i *ngIf="loadingCurrency" class="fa fa-floppy-disk"></i>
													<span *ngIf="currencyType==0">{{ ' $' }}</span>
													<span *ngIf="currencyType==1">{{ ' Q' }}</span>
												</span> -->
											</th>
											<th class="text-right">Subtotal</th>
											<th class="td-center">Opciones</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let product of productList; let i = index">
											<td colspan="4">
												<div class="d-flex align-items-center gap-2">
                                                    <span>{{ product.productData.name }}</span>

                                                    <button
                                                        type="button"
                                                        class="btn btn-sm btn-outline-primary"
                                                        title="Cambiar producto"
                                                        (click)="openProductAlternatives(product)"
                                                        [disabled]="product.loadingAlternatives || product.savingAlternative"
                                                        *ngIf="reverseTranformShowed"
                                                    >
                                                        <i
                                                            class="fa"
                                                            [ngClass]="product.loadingAlternatives
                                                                ? 'fa-spinner fa-spin'
                                                                : 'fa-exchange-alt'"
                                                        ></i>
                                                    </button>
                                                </div>

                                                <div *ngIf="product.showAlternativeSelector" class="mt-2">
                                                    <div class="input-group input-group-sm">
                                                        <select
                                                            class="form-select"
                                                            [(ngModel)]="product.selectedAlternativeId"
                                                            [disabled]="product.savingAlternative"
                                                        >
                                                            <option [ngValue]="null" disabled>
                                                                Selecciona un producto
                                                            </option>

                                                            <option
                                                                *ngFor="let alternative of product.alternativeProducts"
                                                                [ngValue]="alternative.parentProduct.id"
                                                            >
                                                                {{ alternative.parentProduct.code }} - {{ alternative.parentProduct.name }}
                                                                = {{(product.originalQuantity / alternative.factor) | number:"1.2-2"}}
                                                            </option>
                                                        </select>

                                                        <button
                                                            type="button"
                                                            class="btn btn-success"
                                                            (click)="saveProductAlternative(product)"
                                                            [disabled]="
                                                                product.selectedAlternativeId == null ||
                                                                product.savingAlternative
                                                            "
                                                            title="Guardar cambio"
                                                        >
                                                            <i class="fa fa-check"></i>
                                                        </button>

                                                        <button
                                                            type="button"
                                                            class="btn btn-outline-secondary"
                                                            (click)="cancelProductAlternative(product)"
                                                            [disabled]="product.savingAlternative"
                                                            title="Cancelar"
                                                        >
                                                            <i class="fa fa-xmark"></i>
                                                        </button>
                                                    </div>
                                                </div>
											</td>
											<td class="text-right">{{product.quantity}}</td>
											<td>
												<div class="d-flex justify-content-center">
													<input type="number" class="form-control" [(ngModel)]="product.cost"
														style="max-width: 200px; text-align: center;" step="0.01" min="0"/>
												</div>
												<div class="d-flex justify-content-center text-muted" style="font-size: 0.85em;">
													<span>Ultimo: {{ product.lastCost | currency:"Q" }}</span>
												</div>
											</td>
											<td class="text-center">
												<span *ngIf="currencyType==0">{{ 'Q' }}</span>
												<span *ngIf="currencyType==1">{{ '$' }}</span>
											</td>
											<td class="text-right">
												<span *ngIf="currencyType==0">{{ product.quantity*product.cost | currency:"Q" }}</span>
												<span *ngIf="currencyType==1">{{ product.quantity*product.cost | currency:"USD" }}</span>
											</td>
											<td class="td-center">
												<div style="display: flex; justify-content: space-evenly;">
													<span class="clickeable text-danger" (click)="deleteProductFromList(i)">
														<i class="fa fa-trash"></i>
													</span>
												</div>
											</td>
										</tr>
									</tbody>
									<tfoot>
										<tr>
											<td colspan="7" class="text-right font-weight-bold">Total</td>
											<td class="text-right font-weight-bold">
												<span *ngIf="currencyType==0">{{ total | currency:"Q" }}</span>
												<span *ngIf="currencyType==1">{{ total | currency:"USD" }}</span>
											</td>
											<td></td>
										</tr>
									</tfoot>
								</table>
							</div>
						</div>
					</div>
					<p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;"><i
							class="fa fa-circle-info"></i>Completa los campos marcados con un <span
							class="required">*</span> y agrega productos para crear el pedido</p>
				</div>
				<div class="modal-footer">
					<button class="btn btn-success" (click)="createOrder()"
					 [disabled]="loading || !inputs.warehouse.verified || !date || productList.length == 0 || !inputs.provider.verified">
						<ng-container *ngIf="!loading">
							<i class="fa fa-floppy-disk"></i>
						</ng-container>
						<ng-container *ngIf="loading">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>GUARDAR
					</button>
				</div>
			</div>
		</div>
	</div>
</div>